import request from '@/utils/request.js';

export const apiGetFBPost = 
        data => request("get",'/api/v1/fb/get-posts', data)
            .then(function(res){
                return res.data ;
            });
